// webinar page custom functionality
(() => {
  const slugify = (string) => {
    return string
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/--+/g, '-')
      .trim();
  };

  const getDateAttribute = (dateString, type) => {
    const date = new Date(dateString);

    const dateObj = {
      dayOfWeek: date.toLocaleDateString('en-US', { weekday: 'long' }), // Day of the week
      month: date.toLocaleString('en-US', { month: 'long' }), // Full month name
      dayOfMonth: date.getDate(), // Day of the month
      year: date.getFullYear(), // Year
    };

    return dateObj[type] || 'dateData';
  };

  const webinar = {
    showMore: false, // true = no limit, false = limit to 10
    topic: 'show-all',
    init: () => {
      webinar.initDetailsModal();
      webinar.initRegitrationModal();

      const registeredQuery = webinar.getQueryString('registered') === 'true';
      const registeredCookie = webinar.readCookie('registered') === 'true';

      if (registeredQuery && sessionStorage.getItem('webinarTitle')) {
        webinar.showRegistrationNotification();
      } else {
        sessionStorage.removeItem('webinarTitle');
      }

      if (registeredQuery || registeredCookie) {
        webinar.setCookie('registered', 'true', 30);
        document.querySelector('.gated-webinars').classList.remove('locked');
        webinar.initFilter();
        webinar.showFiltered();
      } else {
        document.querySelector('.gated-webinars').classList.add('locked');
      }
    },

    initDetailsModal: () => {
      const modalTriggers = [...document.querySelectorAll('.more-details-btn')];

      for (let trigger of modalTriggers) {
        trigger.removeEventListener('click', webinar.showDetailsModal);
        trigger.removeEventListener('keydown', webinar.showDetailsModal);
        trigger.addEventListener('click', webinar.showDetailsModal);
        trigger.addEventListener('keydown', webinar.showDetailsModal);
      }
    },

    initRegitrationModal: () => {
      const modalTriggers = [...document.querySelectorAll('.register-btn')];
      const webinarRegistrationModal = document.querySelector('#webinar-lead-form-modal');
      const modalTitle = webinarRegistrationModal.querySelector('.form-header');

      webinarRegistrationModal.addEventListener('hidden.bs.modal', () => {
        sessionStorage.removeItem('webinarTitle');
      });

      const updateModalDetails = (event) => {
        const eventElement = event.target;
        const triggerEl = eventElement.closest('.register-btn');
        const webinarId = triggerEl.dataset.id || null;
        const webinarIdField = webinarRegistrationModal.querySelector('input[name="WebinarId"]');

        // webinars array is coming from the webinars-data.js file
        const webinar = webinarId ? webinars.find((webinar) => webinar.id === webinarId) : null;

        if (webinar) {
          modalTitle.innerHTML = webinar.title;

          sessionStorage.setItem('webinarTitle', webinar.title);

          // update acton form hidden field for webinar id
          if (webinarIdField) {
            webinarIdField.value = webinar.id;
          }
        }
        // reset the modal title and field
        else {
          modalTitle.innerHTML = 'Fill out the form to access the recorder webinars.';

          sessionStorage.removeItem('webinarTitle');

          // remove the action form hidden field value
          if (webinarIdField) {
            webinarIdField.value = '';
          }
        }
      };

      for (let trigger of modalTriggers) {
        trigger.addEventListener('click', updateModalDetails);
        trigger.addEventListener('keydown', updateModalDetails);
      }
    },

    showRegistrationNotification: () => {
      const registrationNotice = document.querySelector('.registration-notice');
      const registrationNoticeTitle = registrationNotice.querySelector('.webinar-title');

      const toastEl = new bootstrap.Toast(registrationNotice);

      if (sessionStorage.getItem('webinarTitle')) {
        registrationNoticeTitle.innerHTML = sessionStorage.getItem('webinarTitle');
        toastEl.show();
        sessionStorage.removeItem('webinarTitle');
      }
    },

    showDetailsModal: (event) => {
      const webinarDetailsModal = document.querySelector('#webinar-modal');
      const modalTitle = webinarDetailsModal.querySelector('.webinar-name');
      const webinarDetailsDisplay = webinarDetailsModal.querySelector('.webinar-details');
      const webinarDate = webinarDetailsModal.querySelector('.webinar-date');
      const webinarCta = webinarDetailsModal.querySelector('.webinar-cta');

      event.preventDefault();

      const webinarModal = new bootstrap.Modal('#webinar-modal');

      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const eventElement = event.target;
      const triggerEl = eventElement.closest('.more-details-btn');
      const recordedWebinar = eventElement.closest('.recorded-webinar');

      if (triggerEl) {
        if (event.key === ' ') {
          event.preventDefault();
        }

        // webinars array is coming from the webinars-data.js file
        const webinar = webinars.find(
          (webinar) => slugify(webinar.title) === triggerEl.dataset.slug && slugify(webinar.date) === triggerEl.dataset.date
        );

        if (webinar && webinar.details) {
          modalTitle.innerHTML = webinar.title;
          webinarDate.innerHTML = webinar.date + (webinar.time ? ' - ' + webinar.time : '');
          webinarDetailsDisplay.innerHTML = webinar.details;
          // webinarCta.href = webinar.registrationUrl;
          webinarCta.dataset.id = webinar.id;
        }
        if (recordedWebinar) {
          webinarCta.classList.add('d-none');
        } else {
          webinarCta.classList.remove('d-none');
        }

        webinarModal.show();
      }
    },

    initFilter: () => {
      const filterTrigger = document.getElementById('select-topics');
      filterTrigger.removeEventListener('change', webinar.handleFilterChange);
      filterTrigger.addEventListener('change', webinar.handleFilterChange);
    },

    handleFilterChange: (event) => {
      const target = event && event.target;
      const value = target ? target.value : 'show-all';

      webinar.topic = value;

      webinar.showFiltered(webinar.topic);
    },

    initShowMore: () => {
      const showMoreBtn = document.querySelector('.show-more-btn');
      if (!showMoreBtn) return;
      showMoreBtn.removeEventListener('click', webinar.handleShowMore);
      showMoreBtn.addEventListener('click', webinar.handleShowMore);
    },

    handleShowMore: () => {
      webinar.showMore = true;
      webinar.showFiltered(webinar.topic, webinar.showMore);
    },

    showFiltered: (topic) => {
      const webinarTemplate = (item) => {
        return `
          <div class="recorded-webinar col-lg-12 rounded mb-3 mb-lg-4 py-2">
            <div class="row gx-lg-5">
              <div class="col-lg-8 order-lg-1">
                <p class="opacity-75 mb-1">${item.vertical.join(', ')}</p>
                <h3 class="mb-0">${item.title}</h3>
              </div>
              <div class="col-lg-3 text-lg-end order-lg-0 mt-lg-1">
                <span class="d-inline-block lh-15 align-middle">
                  ${getDateAttribute(item.date, 'month')} ${getDateAttribute(
                    item.date,
                    'dayOfMonth'
                  )}<span class="d-lg-none">,</span> <br class="d-none d-lg-inline-block">
                  ${getDateAttribute(item.date, 'year')}
                </span>
                <span class="d-none d-lg-inline-block opacity-50 align-middle ms-2">
                  <svg aria-label="Date &amp; Time" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M180-630h600v-130H180v130Zm0 0v-130 130Zm0 550q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v307q-14.17-7.29-29.08-12.14Q796-470 780-473v-97H180v430h319q6 17 14 31.5T532-80H180Zm551 40q-78.43 0-133.72-55.28Q542-150.57 542-229t55.28-133.72Q652.57-418 731-418t133.72 55.28Q920-307.43 920-229T864.72-95.28Q809.43-40 731-40Zm58.24-88L817-156l-75-75v-112h-39v126l86.24 89Z"></path></svg>
                </span>
              </div>
              <div class="col-lg-8 order-lg-2 offset-lg-3 mt-3 mb-lg-0">
                <a class="text-success d-inline-block border-0 px-0 me-4" href="#" data-bs-toggle="modal" data-bs-target="#video-modal" data-src="${
                  item.recordingUrl
                }">
                  <svg aria-label="Play" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z"/></svg> 
                  Watch&nbsp;Now
                </a>
                <a class="more-details-btn text-reset d-inline-block border-0" href="#" data-slug="${slugify(
                  item.title
                )}" data-date="${slugify(item.date)}">&raquo;&nbsp;Learn&nbsp;More</a>
              </div>
            </div>
          </div>
        `;
      };

      let webinarHtml = '';

      const recordedWebinars = webinars.filter((webinar) => webinar.recordingUrl !== null);

      const filteredWebinars =
        topic === 'show-all' || !topic
          ? recordedWebinars
          : recordedWebinars.filter(
              (webinar) =>
                webinar.vertical.some((item) => slugify(item) === topic) ||
                webinar.topic.some((item) => slugify(item) === topic)
            );

      filteredWebinars.forEach((item, index) => {
        if (!webinar.showMore) {
          if (index < 10) {
            webinarHtml += webinarTemplate(item);
          }
        } else {
          webinarHtml += webinarTemplate(item);
        }
      });

      const showMoreBtn = `
        <div class="col-12 text-center mt-6 mt-lg-7 mb-5">
          <button class="show-more-btn btn btn-outline-dark btn-lg px-5" type="button">Show More...</button>
        </div>
      `;
      document.querySelector('.recorder-webinar-collection').innerHTML = filteredWebinars.length
        ? webinarHtml + (filteredWebinars.length > 10 && !webinar.showMore ? showMoreBtn : '')
        : '<h4>No recorded webinars found for your topic of choice.</h4>';

      webinar.showMore = false;

      // reinitialize things
      webinar.initDetailsModal();
      webinar.initShowMore();
    },

    readCookie: function (name) {
      let nameEQ = encodeURI(name) + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return decodeURI(c.substring(nameEQ.length, c.length));
      }
      return null;
    },

    setCookie: function (name, value, days) {
      let expires = '';
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      }
      const domain =
        location.hostname == 'localhost'
          ? ''
          : ';domain=.' + location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
      const security = location.hostname == 'localhost' ? '' : ';SameSite=None; Secure';
      document.cookie = name + '=' + value + expires + ';path=/' + domain + security;
    },

    getQueryString: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
  };

  webinar.init();
})();
